import axios from 'axios'

export default {
	getAll(searchParams) {
		return axios.get(window.dtServerUrl + '/mobilesims', {
			params: searchParams
		})
	},

	count(searchParams) {
		return axios.get(window.dtServerUrl + '/mobilesims/count', {
			params: searchParams
		})
	},

	getById(id) {
		return axios.get(window.dtServerUrl + '/mobilesims/' + id)
	},

	getProducts() {
		return axios.get(window.dtServerUrl + '/mobilesims/products')
	},

	getQrCode(id) {
		return axios.get(window.dtServerUrl + '/mobilesims/' + id + '/qrcode')
	},

	getUsage(id) {
		return axios.get(window.dtServerUrl + '/mobilesims/' + id + '/usage')
	},

	suspend(id) {
		return axios.post(window.dtServerUrl + '/mobilesims/' + id + '/suspend').then((response) => {
			return response?.data
		})
	},

	reactivate(id) {
		return axios.post(window.dtServerUrl + '/mobilesims/' + id + '/reactivate').then((response) => {
			return response?.data
		})
	},

	terminate(id) {
		return axios.post(window.dtServerUrl + '/mobilesims/' + id + '/terminate').then((response) => {
			return response?.data
		})
	},

	sendEsimEmail(id, email) {
		return axios.post(window.dtServerUrl + '/mobilesims/' + id + '/sendesimemail', { email }).then((response) => {
			return response?.data
		})
	},

	sync(id) {
		return axios.post(window.dtServerUrl + '/mobilesims/' + id + '/sync').then((response) => {
			return response?.data
		})
	},

	create(sim) {
		return axios.post(window.dtServerUrl + '/mobilesims', sim).then((response) => {
			return response?.data
		})
	},

	update(sim) {
		return axios.put(window.dtServerUrl + '/mobilesims/' + sim.id, sim).then((response) => {
			return response?.data
		})
	},

	delete(id) {
		return axios.delete(window.dtServerUrl + '/mobilesims/' + id)
	}
}
